export const createPattern = (type) => {
  switch(type) {
    case 'cross':
      return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.2'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
    case 'triangles':
      return `data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.2'%3E%3Cpath d='M12 0l12 24H0z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
    case 'dots':
      return `data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.2' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E`;
    case 'rings':
      return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg stroke='%23000000' stroke-opacity='0.2'%3E%3Ccircle cx='30' cy='30' r='20' stroke-width='4'/%3E%3Ccircle cx='30' cy='30' r='10' stroke-width='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
    case 'bubbles':
      return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.2'%3E%3Ccircle cx='10' cy='10' r='8'/%3E%3Ccircle cx='40' cy='40' r='8'/%3E%3Ccircle cx='10' cy='40' r='8'/%3E%3Ccircle cx='40' cy='10' r='8'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
    case 'squares':
      return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Crect x='0' y='0' width='20' height='20'/%3E%3Crect x='40' y='0' width='20' height='20'/%3E%3Crect x='20' y='20' width='20' height='20'/%3E%3Crect x='0' y='40' width='20' height='20'/%3E%3Crect x='40' y='40' width='20' height='20'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
    // Add more patterns as needed
    case 'horizlines':
  return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Crect width='60' height='10'/%3E%3Crect y='20' width='60' height='10'/%3E%3Crect y='40' width='60' height='10'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
case 'diaglines':
  return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Cpath d='M0 0 L60 60' stroke='%23000000' stroke-width='2'/%3E%3Cpath d='M60 0 L0 60' stroke='%23000000' stroke-width='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
case 'vertlines':
  return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Crect width='10' height='60'/%3E%3Crect x='20' width='10' height='60'/%3E%3Crect x='40' width='10' height='60'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
case 'crosshatch':
  return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Crect width='10' height='60'/%3E%3Crect x='20' width='10' height='60'/%3E%3Crect x='40' width='10' height='60'/%3E%3Crect width='60' height='10'/%3E%3Crect y='20' width='60' height='10'/%3E%3Crect y='40' width='60' height='10'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
case 'grid':
    return `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg stroke='%23000000' stroke-opacity='0.1' stroke-width='1'%3E%3Cpath d='M 0 0 H 60 V 60 H 0 Z' fill='none' /%3E%3Cpath d='M 0 10 V 60 M 10 0 H 60 M 0 20 V 60 M 20 0 H 60 M 0 30 V 60 M 30 0 H 60 M 0 40 V 60 M 40 0 H 60 M 0 50 V 60 M 50 0 H 60' fill='none' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E`;
      default:
      return null;
  }
};
export const design_options = [
  {
    pattern: 'triangles',
    patternUrl: createPattern('triangles')
  },
  {
    pattern: 'cross',
    patternUrl: createPattern('cross')
  },
  {
    pattern: 'dots',
    patternUrl: createPattern('dots')
  },
  {
    pattern: 'rings',
    patternUrl: createPattern('rings')
  },
  {
    pattern: 'bubbles',
    patternUrl: createPattern('bubbles')
  },
  {
    pattern: 'squares',
    patternUrl: createPattern('squares')
  },
  {
    pattern: 'horizlines',
    patternUrl: createPattern('horizlines')
  },
  {
    pattern: 'diaglines',
    patternUrl: createPattern('diaglines')
  },
  {
    pattern: 'vertlines',
    patternUrl: createPattern('vertlines')
  },
  {
    pattern: 'crosshatch',
    patternUrl: createPattern('crosshatch')
  },
  {
    pattern: 'grid',
    patternUrl: createPattern('grid')
  }
]
export const template_options = [
  // {
  //   data: { 
  //     name: 'LinkedIn 1:1', 
  //     height: 37.5, 
  //     width: 37.5,
  //     pattern: 'circles',
  //     patternUrl: createPattern('circles')
  //   },
  //   value: 'LinkedIn 1:1',
  //   label: 'LinkedIn 1:1',
  // },
  {
    data: { 
      name: 'LinkedIn 4:5', 
      height: 46.5, 
      width: 37,
      //pattern: 'triangles',
      //patternUrl: createPattern('triangles')
    },
    value: 'LinkedIn 4:5',
    label: 'LinkedIn 4:5',
  },
  // {
  //   data: { 
  //     name: 'Instagram 1:1', 
  //     height: 33.3, 
  //     width: 33.3,
  //     pattern: 'dots',
  //     patternUrl: createPattern('dots')
  //   },
  //   value: 'Instagram 1:1',
  //   label: 'Instagram 1:1',
  // },
  // {
  //   data: { 
  //     name: 'Instagram 4:5', 
  //     height: 46.5, 
  //     width: 37,
  //   //  pattern: 'rings',
  //   //  patternUrl: createPattern('rings')
  //   },
  //   value: 'Instagram 4:5',
  //   label: 'Instagram 4:5',
  // },
  // {
  //   data: { 
  //     name: 'Custom 1:1', 
  //     height: 37.5, 
  //     width: 37.5,
  //     pattern: 'bubbles',
  //     patternUrl: createPattern('bubbles')
  //   },
  //   value: 'Custom 1:1',
  //   label: 'Custom 1:1',
  // },
  // {
  //   data: { 
  //     name: 'Custom 4:5', 
  //     height: 46.5, 
  //     width: 37,
  //     pattern: 'squares',
  //     patternUrl: createPattern('squares')
  //   },
  //   value: 'Custom 4:5',
  //   label: 'Custom 4:5',
  // }
];

export const pattern_options = [
  {
    value: 'circles',
    label: 'Circles',
    patternUrl: createPattern('circles')
  },
  {
    value: 'triangles',
    label: 'Triangles',
    patternUrl: createPattern('triangles')
  },
  {
    value: 'dots',
    label: 'Dots',
    patternUrl: createPattern('dots')
  },
  {
    value: 'rings',
    label: 'Rings',
    patternUrl: createPattern('rings')
  },
  {
    value: 'bubbles',
    label: 'Bubbles',
    patternUrl: createPattern('bubbles')
  },
  {
    value: 'squares',
    label: 'Squares',
    patternUrl: createPattern('squares')
  },
  {
    value: 'lines',
    label: 'Lines',
    patternUrl: createPattern('lines')
  },
  {
    value: 'spiral',
    label: 'Spiral',
    patternUrl: createPattern('spiral')
  }
];

export const font_style = [
  { value: "Lora + Arial", label: "Lora + Arial" },
  { value: "Lora + Helvetica", label: "Lora + Helvetica" },
  { value: "Lora + Tahoma", label: "Lora + Tahoma" },
  { value: "Lora + Verdana", label: "Lora + Verdana" },
  { value: "Poppins + Arial", label: "Poppins + Arial" },
  { value: "Poppins + Helvetica", label: "Poppins + Helvetica" },
  { value: "Poppins + Tahoma", label: "Poppins + Tahoma" },
  { value: "Poppins + Verdana", label: "Poppins + Verdana" },
  { value: "Montserrat + Arial", label: "Montserrat + Arial" },
  { value: "Montserrat + Helvetica", label: "Montserrat + Helvetica" },
  { value: "Montserrat + Tahoma", label: "Montserrat + Tahoma" },
  { value: "Montserrat + Verdana", label: "Montserrat + Verdana" },
  { value: "Roboto + Arial", label: "Roboto + Arial" },
  { value: "Roboto + Helvetica", label: "Roboto + Helvetica" },
  { value: "Roboto + Tahoma", label: "Roboto + Tahoma" },
  { value: "Roboto + Verdana", label: "Roboto + Verdana" },
  { value: "Open Sans + Arial", label: "Open Sans + Arial" },
  { value: "Open Sans + Helvetica", label: "Open Sans + Helvetica" },
  { value: "Open Sans + Tahoma", label: "Open Sans + Tahoma" },
  { value: "Open Sans + Verdana", label: "Open Sans + Verdana" },
  { value: "Nunito + Arial", label: "Nunito + Arial" },
  { value: "Nunito + Helvetica", label: "Nunito + Helvetica" },
  { value: "Nunito + Tahoma", label: "Nunito + Tahoma" },
  { value: "Nunito + Verdana", label: "Nunito + Verdana" },
  { value: "Raleway + Arial", label: "Raleway + Arial" },
  { value: "Raleway + Helvetica", label: "Raleway + Helvetica" },
  { value: "Raleway + Tahoma", label: "Raleway + Tahoma" },
  { value: "Raleway + Verdana", label: "Raleway + Verdana" },
  { value: "Merriweather + Arial", label: "Merriweather + Arial" },
  { value: "Merriweather + Helvetica", label: "Merriweather + Helvetica" },
  { value: "Merriweather + Tahoma", label: "Merriweather + Tahoma" },
  { value: "Merriweather + Verdana", label: "Merriweather + Verdana" },
  { value: "Playfair Display + Arial", label: "Playfair Display + Arial" },
  { value: "Playfair Display + Helvetica", label: "Playfair Display + Helvetica" },
  { value: "Playfair Display + Tahoma", label: "Playfair Display + Tahoma" },
  { value: "Playfair Display + Verdana", label: "Playfair Display + Verdana" },
  { value: "Fira Sans + Arial", label: "Fira Sans + Arial" },
  { value: "Fira Sans + Helvetica", label: "Fira Sans + Helvetica" },
  { value: "Fira Sans + Tahoma", label: "Fira Sans + Tahoma" },
  { value: "Fira Sans + Verdana", label: "Fira Sans + Verdana" },
  { value: "Josefin Sans + Arial", label: "Josefin Sans + Arial" },
  { value: "Josefin Sans + Helvetica", label: "Josefin Sans + Helvetica" },
  { value: "Josefin Sans + Tahoma", label: "Josefin Sans + Tahoma" },
  { value: "Josefin Sans + Verdana", label: "Josefin Sans + Verdana" },
  { value: "Source Sans Pro + Arial", label: "Source Sans Pro + Arial" },
  { value: "Source Sans Pro + Helvetica", label: "Source Sans Pro + Helvetica" },
  { value: "Source Sans Pro + Tahoma", label: "Source Sans Pro + Tahoma" },
  { value: "Source Sans Pro + Verdana", label: "Source Sans Pro + Verdana" },
  { value: "Oswald + Arial", label: "Oswald + Arial" },
  { value: "Oswald + Helvetica", label: "Oswald + Helvetica" },
  { value: "Oswald + Tahoma", label: "Oswald + Tahoma" },
  { value: "Oswald + Verdana", label: "Oswald + Verdana" },
  { value: "Bebas Neue + Arial", label: "Bebas Neue + Arial" },
  { value: "Bebas Neue + Helvetica", label: "Bebas Neue + Helvetica" },
  { value: "Bebas Neue + Tahoma", label: "Bebas Neue + Tahoma" },
  { value: "Bebas Neue + Verdana", label: "Bebas Neue + Verdana" },
];


export const background_design_elements = [
  {
    value: 'Roundly Capsules',
    label: 'Roundly Capsules',
  },{
    value: 'Roundly Squares',
    label: 'Roundly Squares',
  } 
]

export const color_pallete = [
   {
    first_color: '#B36BF7',
    second_color: '#FFFFFF',
    third_color: '#000000'
},
   {
    first_color: '#EB546F',
    second_color: '#FFFFFF',
    third_color: '#220257'
},
 {
  first_color: '#56a3f5',
  second_color: '#ffffff',
  third_color: '#06247f'
},
 {
  first_color: '#1a1d29',
  second_color: '#e6e6e6',
  third_color: '#c5c5ff'
},
 {
  first_color: '#ffffff',
  second_color: '#231b54',
  third_color: '#ee834e'
},
 {
  first_color: '#dde5e7',
  second_color: '#67727e',
  third_color: '#d4674c'
},
 {
  first_color: '#f6f0f0',
  second_color: '#0567a8',
  third_color: '#60e3d5'
},
 {
  first_color: '#F1EDDC',
  second_color: '#474747',
  third_color: '#F8AFA6'
},
{
  first_color: '#F2D7EE',
  second_color: '#262626',
  third_color: '#4F4A7C'
},
{
  first_color: '#D6DBB2',
  second_color: '#3C3C3C',
  third_color: '#e88411'
},
{
  first_color: '#F9E2D2',
  second_color: '#2C2C2C',
  third_color: '#8491C3'
},
{
  first_color: '#280647',
  second_color: '#b3aee9',
  third_color: '#96f7d2'
},
{
  first_color: '#EE8271',
  second_color: '#FFFFFF',
  third_color: '#4D0A65'
},
{
  first_color: '#1a223a',
  second_color: '#e4e4eb',
  third_color: '#ffaf87'
},
{
  first_color: '#1e1e1e',
  second_color: '#f2f2f2',
  third_color: '#52c3c9'
},
{
  first_color: '#2d2d2d',
  second_color: '#f5f5f5',
  third_color: '#ffcc66'
},
{
  first_color: '#1e140f',
  second_color: '#e6d2b1',
  third_color: '#ff9a8d'
},
{
  first_color: '#173d4e',
  second_color: '#e1f1f1',
  third_color: '#ffb347'
},
{
  first_color: '#674da0',
  second_color: '#ffffff',
  third_color: '#fac318'
},
{
  first_color: '#f3e5f5',
  second_color: '#2b1a30',
  third_color: '#ff8a80'
},
{
  first_color: '#e1f5fe',
  second_color: '#23395b',
  third_color: '#ff8a65'
},
{
  first_color: '#2b2b2b',
  second_color: '#f7f7f7',
  third_color: '#f44336'
},
{
  first_color: '#eeeeee',
  second_color: '#212121',
  third_color: '#fbc02d'
},
{
  first_color: '#f1f8e9',
  second_color: '#37474f',
  third_color: '#ff9800'
},
{
  first_color: '#f2f3f4',
  second_color: '#2c3e50',
  third_color: '#e74c3c'
},
{
  first_color: '#f1f8e9',
  second_color: '#424242',
  third_color: '#ffab91'
},
{
  first_color: '#90a4ae',
  second_color: '#ffffff',
  third_color: '#ffcc80'
},
{
  first_color: '#f9fbe7',
  second_color: '#455a64',
  third_color: '#9c27b0'
},
{
  first_color: '#fafafa',
  second_color: '#424242',
  third_color: '#4db6ac'
},
{
  first_color: '#ede7f6',
  second_color: '#212121',
  third_color: '#ff9800'
},
{
  first_color: '#F4B94D',
  second_color: '#FFFFFF',
  third_color: '#1D1D76'
},
{
  first_color: '#09213E',
  second_color: '#FFFFFF',
  third_color: '#70F1E8'
},
{
  first_color: '#EE834E',
  second_color: '#FFFFFF',
  third_color: '#711342'
},
{
  first_color: '#fcf078',
  second_color: '#2e0000',
  third_color: '#eb4b62'
},
{
  first_color: '#ecc9bf',
  second_color: '#064e84',
  third_color: '#cf3a72'
},
{
  first_color: '#273b2f',
  second_color: '#a5c0af',
  third_color: '#e1bd67'
},
]